/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown>, breakdown: NonNullable<unknown> }} Sub_Overview_Of_Total_GbInputs */



/**
* | output |
* | --- |
* | "of {total} GB ({breakdown})" |
*
* @param {Sub_Overview_Of_Total_GbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_of_total_gb = /** @type {((inputs: Sub_Overview_Of_Total_GbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Of_Total_GbInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von ${i?.total} GB (${i?.breakdown})`)
	return /** @type {LocalizedString} */ (`of ${i?.total} GB (${i?.breakdown})`)
});